import { Injectable } from "@angular/core";
import { BaseCrudService } from "src/app/services/apps/generic/base.service";
import {
  IPendingOrderCreateDTO,
  IPendingOrderGetDTO,
  IPendingOrderUpdateDTO,
} from "./models";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class PendingOrderService extends BaseCrudService<
  IPendingOrderGetDTO,
  IPendingOrderCreateDTO,
  IPendingOrderUpdateDTO,
  string
> {
  constructor() {
    super(environment.endpoints.orders.orders);
  }
}
